import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { FaCookieBite } from 'react-icons/fa';

const CookieConsent = () => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            // Show after 1 second delay
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setIsVisible(false);
    };

    const declineCookies = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return createPortal(
        <div className="cookie-consent">
            <div className="cookie-content">
                <div className="cookie-icon">
                    <FaCookieBite />
                </div>
                <div className="cookie-text">
                    <p>
                        {t('cookies.message')}
                        {' '}
                        <a href="/privacy">{t('cookies.policy')}</a>.
                    </p>
                </div>
                <div className="cookie-buttons">
                    <button className="btn-cookie-accept" onClick={acceptCookies}>
                        {t('cookies.accept')}
                    </button>
                    <button className="btn-cookie-decline" onClick={declineCookies}>
                        {t('cookies.decline')}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default CookieConsent;
